(function(){
  if(window.__L4MProductGalleryViewerLoaded) return;
  window.__L4MProductGalleryViewerLoaded=true;

  let activeViewer=null;
  let activeIndex=0;
  let restoreFocus=null;

  function items(viewer){return Array.from(viewer.querySelectorAll('template[data-l4m-gallery-item]'));}
  function clampIndex(viewer,index){const all=items(viewer);if(!all.length)return 0;return ((index%all.length)+all.length)%all.length;}
  function clearContent(viewer){
    const host=viewer&&viewer.querySelector('[data-l4m-gallery-content]');
    if(!host) return;
    host.querySelectorAll('video').forEach(v=>{try{v.pause();}catch(e){}});
    host.innerHTML='';
  }
  function show(viewer,index){
    const all=items(viewer); if(!all.length) return;
    activeIndex=clampIndex(viewer,index);
    const item=all[activeIndex];
    const host=viewer.querySelector('[data-l4m-gallery-content]');
    if(host){
      clearContent(viewer);
      host.appendChild(item.content.cloneNode(true));
      const mediaType=item.dataset.mediaType||'';
      host.dataset.mediaType=mediaType;
    }
    const current=viewer.querySelector('[data-l4m-gallery-current]');
    if(current) current.textContent=String(activeIndex+1);
  }
  function open(viewer,index,trigger){
    if(!viewer) return;
    activeViewer=viewer; restoreFocus=trigger||document.activeElement;
    viewer.hidden=false; viewer.setAttribute('aria-hidden','false');
    document.body.classList.add('l4m-gallery-is-open');
    show(viewer,Number.isFinite(index)?index:0);
    requestAnimationFrame(()=>viewer.querySelector('[data-l4m-gallery-close]')?.focus());
  }
  function close(viewer){
    if(!viewer) return;
    clearContent(viewer);
    viewer.hidden=true; viewer.setAttribute('aria-hidden','true');
    document.body.classList.remove('l4m-gallery-is-open');
    activeViewer=null;
    if(restoreFocus && typeof restoreFocus.focus==='function') restoreFocus.focus({preventScroll:true});
    restoreFocus=null;
  }

  document.addEventListener('click',function(e){
    const trigger=e.target.closest('[data-l4m-gallery-open]');
    if(trigger){
      const id=trigger.getAttribute('data-l4m-viewer-target');
      const viewer=id?document.getElementById(id):null;
      if(viewer){e.preventDefault();open(viewer,parseInt(trigger.getAttribute('data-l4m-gallery-index')||'0',10),trigger);return;}
    }
    const closeBtn=e.target.closest('[data-l4m-gallery-close]');
    if(closeBtn){close(closeBtn.closest('[data-l4m-gallery-viewer]'));return;}
    const prev=e.target.closest('[data-l4m-gallery-prev]');
    if(prev){const viewer=prev.closest('[data-l4m-gallery-viewer]');show(viewer,activeIndex-1);return;}
    const next=e.target.closest('[data-l4m-gallery-next]');
    if(next){const viewer=next.closest('[data-l4m-gallery-viewer]');show(viewer,activeIndex+1);return;}
  });

  document.addEventListener('keydown',function(e){
    if(!activeViewer){
      if(e.key==='Enter' || e.key===' '){
        const trigger=e.target.closest && e.target.closest('[data-l4m-gallery-open]');
        if(trigger){
          const id=trigger.getAttribute('data-l4m-viewer-target');
          const viewer=id?document.getElementById(id):null;
          if(viewer){e.preventDefault();open(viewer,parseInt(trigger.getAttribute('data-l4m-gallery-index')||'0',10),trigger);}
        }
      }
      return;
    }
    if(e.key==='Escape'){e.preventDefault();close(activeViewer);}
    else if(e.key==='ArrowLeft'){e.preventDefault();show(activeViewer,activeIndex-1);}
    else if(e.key==='ArrowRight'){e.preventDefault();show(activeViewer,activeIndex+1);}
  });

  let touchStartX=null;
  document.addEventListener('touchstart',function(e){
    if(!activeViewer || !e.target.closest('[data-l4m-gallery-stage]')) return;
    touchStartX=e.changedTouches[0].clientX;
  },{passive:true});
  document.addEventListener('touchend',function(e){
    if(!activeViewer || touchStartX===null || !e.target.closest('[data-l4m-gallery-stage]')) return;
    const dx=e.changedTouches[0].clientX-touchStartX; touchStartX=null;
    if(Math.abs(dx)>45) show(activeViewer,activeIndex+(dx<0?1:-1));
  },{passive:true});
})();
